export default __webpack_public_path__ + "static/media/criticalIllness.d5938c97.svg";